var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox" }, [
    _c(
      "div",
      { staticClass: "app-container" },
      [
        _c("el-card", { staticClass: "box-card", attrs: { shadow: "never" } }, [
          _c(
            "div",
            { staticClass: "search-section" },
            [
              _c("div", { staticClass: "search-header" }, [
                _c("div", { staticClass: "search-title" }, [
                  _c("i", { staticClass: "el-icon-search" }),
                  _vm._v("\n          筛选搜索\n        "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "toolbar-row" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.onSearch },
                      },
                      [_vm._v("搜索")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      { attrs: { size: "small" }, on: { click: _vm.onReset } },
                      [_vm._v("重置")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "small",
                          plain: "",
                          loading: _vm.exportLoading,
                        },
                        on: { click: _vm.onExport },
                      },
                      [_vm._v("导出")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  staticClass: "search-form",
                  attrs: { inline: "", size: "small" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "卡密批次：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.searchPram.batchNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchPram, "batchNo", $$v)
                          },
                          expression: "searchPram.batchNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "卡号：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.searchPram.cardNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchPram, "cardNo", $$v)
                          },
                          expression: "searchPram.cardNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "卡状态：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.searchPram.cardStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchPram, "cardStatus", $$v)
                            },
                            expression: "searchPram.cardStatus",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "已入库", value: 1 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "下单锁定", value: 2 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "已发放未激活", value: 3 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "已激活", value: 4 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "已过期", value: 5 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "已作废", value: 6 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "售后锁定", value: 7 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "可使用", value: 8 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "未开始", value: 9 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isMeijingCard
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "使用状态：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { placeholder: "请选择", clearable: "" },
                              model: {
                                value: _vm.searchPram.cardUseStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchPram, "cardUseStatus", $$v)
                                },
                                expression: "searchPram.cardUseStatus",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "未使用", value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "部分使用", value: 2 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "全部使用", value: 3 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMeijingCard
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "手机号：" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请输入",
                              maxlength: "11",
                              oninput: "value=value.replace(/\\D/g,'')",
                              clearable: "",
                            },
                            model: {
                              value: _vm.searchPram.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchPram, "phone", $$v)
                              },
                              expression: "searchPram.phone",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "使用渠道：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.searchPram.channelType,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchPram, "channelType", $$v)
                            },
                            expression: "searchPram.channelType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "小程序", value: 1 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isMeijingCard
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "关联小程序：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.searchPram.customerId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchPram, "customerId", $$v)
                                },
                                expression: "searchPram.customerId",
                              },
                            },
                            _vm._l(_vm.customerOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "创建时间：" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "timeRangeWidth",
                        attrs: {
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                        },
                        model: {
                          value: _vm.searchPram.createTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchPram, "createTime", $$v)
                          },
                          expression: "searchPram.createTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-section" },
            [
              _c(
                "div",
                { staticClass: "goods-toolbar" },
                [
                  _c("div", { staticClass: "goods-title" }, [
                    _vm._v("商品名称：" + _vm._s(_vm.productName || "-")),
                  ]),
                  _vm._v(" "),
                  _vm.isMeijingCard
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.openImportDialog },
                        },
                        [_vm._v("导入卡密")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "table",
                  attrs: {
                    data: _vm.tableData,
                    size: "mini",
                    border: "",
                    "header-cell-style": {
                      fontWeight: "600",
                      background: "#f8fafc",
                      color: "#2d3748",
                    },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "id",
                      label: "卡ID",
                      width: "80",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "batchNo",
                      label: "卡密批次",
                      "min-width": "160",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "channelTypeDesc",
                      label: "使用渠道",
                      "min-width": "100",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cardNo",
                      label: "卡号",
                      "min-width": "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cardSecret",
                      label: "卡密",
                      "min-width": "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_vm._v(_vm._s(_vm.maskCardPwd(scope.row)))]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "validityDesc",
                      label: "一卡通有效期",
                      "min-width": "220",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "soldOrderNo",
                      label: "订单号",
                      "min-width": "230",
                      "show-overflow-tooltip": true,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_vm._v(_vm._s(scope.row.soldOrderNo || "-"))]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "remark",
                      label: "备注",
                      "min-width": "160",
                      "show-overflow-tooltip": true,
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cardStatusDesc",
                      label: "卡状态",
                      "min-width": "110",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.cardStatusTagType(
                                    scope.row.cardStatus
                                  ),
                                  size: "mini",
                                },
                              },
                              [_vm._v(_vm._s(scope.row.cardStatusDesc || "-"))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  !_vm.isMeijingCard
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "cardUseStatusDesc",
                          label: "卡使用状态",
                          "min-width": "100",
                          align: "center",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMeijingCard
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "phone",
                          label: "手机号",
                          "min-width": "130",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMeijingCard
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "customerName",
                          label: "关联小程序",
                          "min-width": "160",
                          "show-overflow-tooltip": true,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(scope.row.customerName || "-")
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2107322824
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "创建时间",
                      "min-width": "160",
                    },
                  }),
                  _vm._v(" "),
                  !_vm.isMeijingCard
                    ? _c("el-table-column", {
                        attrs: {
                          label: "操作",
                          width: "110",
                          fixed: "right",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleUseDetail(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("使用详情")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3106821649
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.searchPram.page,
                      "page-sizes": [20, 50, 100],
                      layout: "total, sizes, prev, pager, next",
                      total: _vm.total,
                      background: "",
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("use-detail-dialog", { ref: "useDetailDialog" }),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "导入卡密",
              visible: _vm.importDialogVisible,
              width: "560px",
              "append-to-body": "",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.importDialogVisible = $event
              },
              closed: _vm.resetImportDialog,
            },
          },
          [
            _c(
              "div",
              { staticClass: "import-dialog-center" },
              [
                _c(
                  "div",
                  { staticClass: "template-row" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleDownloadTemplate },
                      },
                      [_vm._v("下载模板")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-upload",
                  {
                    ref: "importUpload",
                    staticClass: "upload-area",
                    attrs: {
                      drag: "",
                      action: "#",
                      "auto-upload": false,
                      "show-file-list": false,
                      "on-change": _vm.handleImportFileChange,
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-upload upload-icon" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "el-upload__text" }, [
                      _c("div", [_vm._v("点击或拖拽文件到此区域上传")]),
                      _vm._v(" "),
                      _c("div", [_vm._v("支持扩展名：.xlsx")]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.importFileName
                  ? _c(
                      "div",
                      { staticClass: "file-name" },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.importFileName))]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: { click: _vm.handleRemoveImportFile },
                          },
                          [_vm._v("删除")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { slot: "footer" }, slot: "footer" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { disabled: _vm.importSubmitting },
                    on: {
                      click: function ($event) {
                        _vm.importDialogVisible = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", loading: _vm.importSubmitting },
                    on: { click: _vm.handleConfirmImport },
                  },
                  [_vm._v("确定导入")]
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }